import React from 'react'
import QrCode from 'qrcode.react'

const QbQrCode = ({
  style,
  size,
  value,
  className
}) => (
  <div className={className} style={style}>
    <QrCode value={value} size={size} />
  </div>
)

export default QbQrCode



// WEBPACK FOOTER //
// ./src/components/shared/QbQrCode/QbQrCode.js